import React from 'react';

import { css } from '@emotion/core';
import { mq } from '@helpers/breakpoints';
import { Box, Text } from '@rebass/emotion';
import Colors from '@theme/colors';

interface ProgressBarProps {
  step: number;
  descriptions: string[];
}

const ProgressBar = ({ step, descriptions }: ProgressBarProps) => {
  let width = '0%';

  if (step === 1) {
    width = '4%';
  }

  if (step === 2) {
    width = '96%';
  }

  const active = css`
    border: 1px solid #58c323;
  `;

  return (
    <>
      <Box
        bg={Colors.grayDark9}
        css={mq({
          width: ['80%', '50%'],
          height: ['8px'],
          overflow: ['visible'],
          position: ['relative'],
          borderRadius: '25px',
          margin: '24px auto',
        })}
      >
        <Box
          css={css`
            background-color: #58c323;
            border-radius: 25px 0px 0px 25px;
            background-position-y: 50%;
            height: 100%;
            width: ${width};
            }
          `}
        >
          <div
            css={css`
              position: absolute;
              border-radius: 100%;
              height: 32px;
              width: 32px;
              color: #fff;
              background: #58c323;
              border: 1px solid #ddd;
              top: -12px;
              line-height: 29px;
              font-weight: 800;
              text-align: center;
              left: 4%;
              ${step === 2 && active}
            `}
            name="counter1"
          >
            1
          </div>
          <div
            css={css`
              position: absolute;
              border-radius: 100%;
              height: 32px;
              width: 32px;
              background: #58c323;
              color: #fff;
              border: 1px solid #ddd;
              top: -12px;
              line-height: 29px;
              font-weight: 800;
              text-align: center;
              right: 4%;
              ${step === 3 && active}
            `}
            name="counter2"
          >
            2
          </div>
        </Box>
      </Box>
      <Text
        fontSize={[1]}
        css={css`
          width: 100%;
          margin: 24px 0;
          letter-spacing: 0;
          line-height: 20px;
          text-align: center;
        `}
        dangerouslySetInnerHTML={{
          __html: descriptions[step - 1],
        }}
      />
    </>
  );
};

export { ProgressBar };
